// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__13JeD","author":"Table_author__dOTF5","authorImage":"Table_authorImage__3QUsu","unreadRow":"Table_unreadRow__3NZy-"};